import Select from "react-select";

import * as React from 'react';

class ButtonsBlock extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      showDeclinePopup: false,
      showChangeRequiredPopup: false,
      showApprovePopup: false,
      showInformationRequiredPopup: false,
      showManualExecutionPopup: false
    }
  }

  showDeclinePopup() {
    this.setState({showDeclinePopup: true})
  }

  hideDeclinePopup() {
    this.setState({showDeclinePopup: false})
  }

  showChangeRequiredPopup() {
    this.setState({showChangeRequiredPopup: true})
  }

  showManualExecutionPopup() {
    this.setState({showManualExecutionPopup: true})
  }

  hideChangeRequiredPopup() {
    this.setState({showChangeRequiredPopup: false})
  }

  showApprovePopup() {
    this.setState({showApprovePopup: true})
  }

  hideApprovePopup() {
    this.setState({showApprovePopup: false})
  }

  hideManualExecutionPopup() {
    this.setState({showManualExecutionPopup: false})
  }

  onApprove(reason) {
    this.post(`/api/updateRequests/${this.props.uuid}/approve/`, reason);
  }

  onDecline(reason) {
    this.post(`/api/updateRequests/${this.props.uuid}/decline/`, reason);
  }

  onChangeRequired(reason) {
    this.post(`/api/updateRequests/${this.props.uuid}/changeRequired/`, reason);
  }

  onInformationRequired(reason) {
    this.post(`/api/updateRequests/${this.props.uuid}/informationRequired/`, reason);
  }

  onManuallyExecute(reason) {
    this.post(`/api/updateRequests/${this.props.uuid}/executeManually/`, reason);
  }

  post(url, reason) {
    radio('showLoader').broadcast();
    $.ajax({
      url: url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
          reason: reason
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        window.location.reload()
      } else {
        radio('showAlert').broadcast('warning', `Action failed: ${response.message} (${response.status})`)
      }
    }).fail((response, textStatus) => {
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  render() {
    return (
        <div className="headerButtons">
          <button type="button" className="btn-primary headerButton" onClick={this.showManualExecutionPopup.bind(this)}>
            Manual Review
          </button>
          <button type="button" className="btn-primary headerButton" onClick={() => this.setState({ showInformationRequiredPopup: true })}>
            Information Required
          </button>
          <button type="button" className="btn-primary headerButton" onClick={this.showApprovePopup.bind(this)}>
            Approve
          </button>
          <button type="button" className="btn-primary headerButton" onClick={this.showDeclinePopup.bind(this)}>
            Decline
          </button>
          <button type="button" className="btn-primary headerButton" onClick={this.showChangeRequiredPopup.bind(this)}>
            Change Required
          </button>
          <ReasonPickerPopup
            showing={this.state.showInformationRequiredPopup}
            onEsc={() => this.setState({ showInformationRequiredPopup: false })}
            title="Information Required"
            onValidate={this.onInformationRequired.bind(this)}
            action={'information_required'}
            uuid={this.props.uuid}
          />
          <ReasonPickerPopup
              showing={this.state.showDeclinePopup}
              onEsc={this.hideDeclinePopup.bind(this)}
              title="Decline"
              onValidate={this.onDecline.bind(this)}
              action={'declined'}
              uuid={this.props.uuid}
          />
          <ReasonPickerPopup
              showing={this.state.showChangeRequiredPopup}
              onEsc={this.hideChangeRequiredPopup.bind(this)}
              title="Change Required"
              onValidate={this.onChangeRequired.bind(this)}
              action={'change_required'}
              uuid={this.props.uuid}
          />
          <ReasonPickerPopup
              showing={this.state.showApprovePopup}
              onEsc={this.hideApprovePopup.bind(this)}
              title="Approve"
              onValidate={this.onApprove.bind(this)}
              action={'approved'}
              uuid={this.props.uuid}
          />
          <ReasonPickerPopup
              showing={this.state.showManualExecutionPopup}
              onEsc={this.hideManualExecutionPopup.bind(this)}
              title="Manual Review"
              onValidate={this.onManuallyExecute.bind(this)}
              action={'manually_executed'}
              uuid={this.props.uuid}
          />
        </div>
    );
  }
}

class ReasonPickerPopup extends waffle.popups.PopupComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      reason: undefined,
      reasons: []
    }
    this.loadReasons()
  }

  humanize(s) {
    const s2 = s.replace(/\_/g, ' ')
    return s2[0].toUpperCase() + s2.slice(1)
  }

  loadReasons() {
    $.ajax({
      url: `/api/updateRequests/${this.props.uuid}/reasons?action=${this.props.action}`,
      method: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setState({
          isLoading: false,
          reasons: response.data.map(r => { return {label: this.humanize(r), value: r}}).sort((a, b) => {
              if (a.label < b.label) {
                return -1;
              } else if (a.label > b.label) {
                return 1;
              }
              return 0;
          })
        })
      } else {
        radio('showAlert').broadcast('warning', `Failed to retrieve reasons: ${response.message} (${response.status})`)
      }
    }).fail((response, textStatus) => {
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  onChange(value) {
    this.setState({reason: value.value})
  }

  getContent() {
    return (
        <div>
          <div className="popupTitle">{this.props.title}</div>
          <div className="popupSelect">
          <Select
              className='reasonSelect'
              onChange={value => this.onChange(value)}
              options={this.state.reasons}
              inputValue={this.state.inputValue}
              onInputChange={inputValue => this.setState({ inputValue: inputValue })}
              placeholder={'Select a reason...'}
              searchable={false}
              clearable={false}
              cacheAsyncResults={false}
          /></div>
          <div className="popupButton">
            <button
                type="button"
                className="btn-primary headerButton"
                onClick={() => {this.props.onValidate(this.state.reason)}}
                disabled={this.state.isLoading || this.state.reason === undefined}>
              Ok
            </button>
          </div>
        </div>
    );
  }
}

module.exports = {
  ButtonsBlock,
};
